import React from 'react';
import { Box, Typography } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';

interface SectionInsertableDropZoneProps {
  insertIndex: number;
  isVisible: boolean;
}

const SectionInsertableDropZone: React.FC<SectionInsertableDropZoneProps> = ({ insertIndex, isVisible }) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `section-reorder-zone-${insertIndex}`,
    data: {
      type: 'section-reorder-zone',
      insertIndex,
    },
    disabled: !isVisible,
  });

  if (!isVisible) return null;

  return (
    <Box
      ref={setNodeRef}
      sx={{
        height: isOver ? 40 : 12, // Slightly more height for visibility
        mx: 1,
        borderRadius: 1,
        backgroundColor: isOver ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.02)',
        border: isOver ? '2px dashed' : '1px dashed',
        borderColor: isOver ? 'primary.main' : 'rgba(25, 118, 210, 0.2)',
        transition: 'all 0.2s ease',
        opacity: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isOver && (
        <Typography
          variant='caption'
          sx={{
            color: 'primary.main',
            fontSize: '0.75rem',
            fontWeight: 'medium',
            px: 1,
          }}
        >
          Drop section here
        </Typography>
      )}
    </Box>
  );
};

export default SectionInsertableDropZone;
